import { render, staticRenderFns } from "./DropoffPoints.vue?vue&type=template&id=099a2ba4&scoped=true"
import script from "./DropoffPoints.vue?vue&type=script&lang=js"
export * from "./DropoffPoints.vue?vue&type=script&lang=js"
import style0 from "./DropoffPoints.vue?vue&type=style&index=0&id=099a2ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a2ba4",
  null
  
)

export default component.exports